import { Checkbox, Input, Radio } from '@mui/material';
import React,{Component} from 'react';

export default class MQTSelectBox extends Component{
    
    
    onElemClick = (event) => {
   
        this.props.onClick(event.target.checked)
    }

    render(){
        
        console.debug("this.props.checked" ,this.props.checked)
        return <div key={this.props.questionID+"_"+this.props.value} className='' >
                    {this.props.type === "radio" ? 
                        <Radio sx={{width:'fit-content'}} checked={this.props.checked} onChange={this.onElemClick}  className='mqt-checkbox-container'/>
                    : null}
                    {this.props.type === "checkbox" ? 
                        
                        <Checkbox sx={{width:'fit-content'}} checked={this.props.checked} onChange={this.onElemClick}  className='mqt-checkbox-container'/>
                    : null}
                    {/* <input checked={this.props.checked} type={this.props.type} className='mqt-checkbox-container' onClick={this.onElemClick} ></input> */}
                </div>
    }

}